import Highcharts from 'highcharts';
import * as Nested from '../core/nested-property-helpers.js';
import {getLabelFromDictionary} from '../core/dictionary.js';
import tmpl from '../core/simple-template.js';

export function fixCode(code) {
   if ((typeof code !== 'string' && !(code instanceof String)) || code.length < ((code < 2 || code > 999) ? 4 : 3)) {
      return ("0000"+code).slice((code < 2 || code > 999) ? -4 : -3);
   }
   return code;
}

export function getEconomyFct(dictionaryOptions) {
   return (dictionaryOptions.enabled) 
      ? function(code) {
         return getLabelFromDictionary(fixCode(code), dictionaryOptions);
      }
      : function(code) {
         return code;
      }
}

function getFormatterFct(tmplFct, economyFct) {
   if (Array.isArray(tmplFct)) {
      return function() {
         var that = this, args = arguments;
         return tmplFct.map(function(fct) {
            return fct({data: that, args: args, getEconomy: economyFct})
         });
      };    
   } else {
      return function() {
         return tmplFct({data: this, args: arguments, getEconomy: economyFct});
      };
   }
}

function getFormatter(template, economyFct) {
   if (Array.isArray(template)) {
      return getFormatterFct(template.map(function(str) { return tmpl(str); }), economyFct);
   } else {
      return getFormatterFct(tmpl(template), economyFct);
   }
}

export function convertFormatters(config, dictionaryOptions) {
   Object.keys(config).forEach(function(key) {
      var cfg = config[key];
      if ((key == 'formatter' || key.endsWith('Formatter')) && (Array.isArray(cfg) || typeof cfg == 'string')) {
         config[key] = getFormatter(cfg, getEconomyFct(dictionaryOptions));
      } else if (cfg && typeof cfg == 'object') {
         convertFormatters(cfg, dictionaryOptions);
      }
   });
}

function getHeaderFooterFormatterHandler(loadEvtFct) {
   return function() {
      Highcharts.addEvent(this.tooltip, 'headerFormatter', function(e) {
         var headerFooter = (!e.isFooter) ? 'header' : 'footer',
             handler = Nested.get(e,'labelConfig.series.tooltipOptions.' + headerFooter + 'Formatter');
         if (handler) {
            e.text = handler.call(e.labelConfig.point);
            return false; // prevent default
         }
         return true; // run default
      });
      if (loadEvtFct) loadEvtFct.apply(this, arguments);
   }
}

export function addHeaderFooterFormatterSupport(config) {
   if (Nested.hasOwn(config, 'tooltip.headerFormatter') 
       || Nested.hasOwn(config, 'tooltip.footerFormatter')
       || Nested.hasOwn(config, 'series.+.tooltip.headerFormatter')
       || Nested.hasOwn(config, 'series.+.tooltip.footerFormatter')) {
      Nested.set(config, 'chart.events.load', getHeaderFooterFormatterHandler(Nested.get(config,'chart.events.load')));
   }
}